import Stage from '../components/stage/Stage';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import setGlobalState from '../../../redux/setGlobalState';
import LoginForm from './loginForm/LoginForm';
import {useSelector} from 'react-redux';
import {useState} from 'react';
import {Case, Switch} from 'react-if';
import Code from './code/Code';
import {loginByEmail, loginUser, resetPassword} from '../../../redux/user/userActions';
import * as Yup from 'yup';
import {useTranslation} from 'react-i18next';
import {Form, Formik} from 'formik';
import useErrorMessages from '../../../hooks/useErrorMessages';
import SupportComponent from '../../../layout/supportComponent/SupportComponent';
import useTimeout from '../../../hooks/useTimeout';
import useEffectOnUpdate from '../../../hooks/useEffectOnUpdate';
import {sendPostMessage} from '../signUp/SignUp';
import VerifyUserPop from '../../../layout/topMenu/verifyUserPop/VerifyUserPop';
import useShow from '../../../hooks/useShow';
import ForgotPassword from './forgotPassword/ForgotPassword';
import {useSearchParams} from '../../../hooks/useSearchParams';
import {refreshTokenApplicationAndRedirect} from '../../../functions/refreshTokenApplication';
import yupMethods from '../../../functions/validationsYup';
// import OtherWay from './otherWay/OtherWay';  //note:If you delete it you must remove this files
import UserMessage, {bounceMessage} from '../../../layout/userMessages/UserMessage';
import {getDefaultPath} from '../../../utils/routerUtils';

function Login({pageType = null}) {
    const {loginByEmailXHR,defaultPid,defaultEid}=useSelector(state=>state.user);
    const {isPrevPath,noPackageOrEvent,isInactiveUser}=useSelector(state=>state.ui.login);
    const {isLoggedIn, isApplication, applicationExp}=useSelector(state=>state.auth);

    const navigate=useNavigate();
    const [currentPage,setCurrentPage]=useState(pageType || 'signIn');
    const [isPassword,setIsPassword]=useState(false);
    const [lastPassword, setLastPassword] = useState('');
    const {t} = useTranslation('login');
    const {t: globalT} = useTranslation('global');
    const timer=useTimeout();
    const showVerifyPop = useShow();
    const {token} = useSearchParams();
    const isIframe=window.parent !== window.self;

    useErrorMessages();

    useEffect(()=>{
        const now = new Date();
        if(isApplication && applicationExp && now < new Date(applicationExp * 1000)){
            refreshTokenApplicationAndRedirect().then();
            return;
        }
        if(!isLoggedIn)
            return;
        if(!defaultEid&&!defaultPid){
            return;
        }
        
        setGlobalState('user.loginUserXHR',null);
        if(isPrevPath)
            navigate(-1);
        else
            navigate(getDefaultPath(defaultPid,defaultEid));
        if(isIframe)
            sendPostMessage('signUp');
    },[defaultPid,isLoggedIn,defaultEid]);

    useEffect(()=>{
        if(noPackageOrEvent){
            navigate('/signUp');
            setGlobalState('auth.noPackageOrEvent',null);}
    },[noPackageOrEvent]);

    useEffectOnUpdate(()=>{
        isInactiveUser && showVerifyPop.open();
    },[isInactiveUser]);

    useEffectOnUpdate(()=>{
        if(loginByEmailXHR==='SUCCESS'){
            setCurrentPage('code');
            setGlobalState('user.loginByEmailXHR',null);
        }
    },[loginByEmailXHR]);

    const resetLoginXHR=(action)=> {
        timer.current=setTimeout(() => {
            setGlobalState(`user.${action}XHR`, null);
        }, 2000);
    };

    const onSubmit = (values) => {
        const {email,sendToEmail,password, password2}=values;
        if(currentPage==='resetPassword'){
            resetPassword(email, password, password2, token);
        } else if(isPassword && !(values.sendToEmail)){
            if(password === lastPassword){
                bounceMessage(t('incorrectDetails'), 'warning');
                return;
            } else {
                setLastPassword(password);
            }
            loginUser({email,password},true).then((res)=>{
                if(res?.isCodeSend)
                    setCurrentPage('code');
                resetLoginXHR('loginUser');
            });
        }
        else
            loginByEmail(email,sendToEmail).then(()=>resetLoginXHR('loginByEmail'));
    };

    yupMethods();
    const validationPassword=Yup.string().matches(/^[^\u0590-\u05FF]*$/, t('hebrewChars'));

    const validationSchema = Yup.object().shape({
        email: Yup.string().email().required(),
        password: isPassword ? validationPassword.required().minLength(6, globalT('errorMinLength', {min: 6})) : validationPassword,
        password2: validationPassword.oneOf([Yup.ref('password'), null], t('passwordsNotEqual'))
    });
    const existingUserEmail=useSelector(s=>s.ui.login.existingUserEmail);
    return (
        <>
            <title>{'Tickchak | login - התחברות'}</title>
            {showVerifyPop.isOpen && <VerifyUserPop show={showVerifyPop}/>}
            <Formik
                initialValues={{email:existingUserEmail||'' ,password:'',sendToEmail:false}}
                validationSchema={validationSchema}
                onSubmit={onSubmit}>
                <Form  >
                    <Stage >
                        {!isIframe && <SupportComponent />}
                        <Switch >
                            <Case condition={currentPage==='signIn'}>
                                <LoginForm setCurrentPage={setCurrentPage} isPassword={isPassword} setIsPassword={setIsPassword}/>
                            </Case>
                            <Case condition={currentPage==='code'}>
                                <Code setCurrentPage={setCurrentPage}/>
                            </Case>
                            <Case condition={currentPage==='resetPassword'}>
                                <ForgotPassword setCurrentPage={setCurrentPage} />
                            </Case>
                            {/* <Case condition={'otherWay'===currentPage}>
                            note:If you delete it you must remove this files
                                <OtherWay setCurrentPage={setCurrentPage} />
                            </Case> */}
                        </Switch>

                    </Stage>
                </Form>
            </Formik>
            <UserMessage />
        </>
    );
}

export default Login;

